<template>
 <div class="nav-menus">
   
   <div class="menu-content" :class="menu">
     <p class="logo logo-menu">Parceiro</p>
     <ul>
          <li class="nav-item active">
            <a class="nav-link" href="#"><br><span class="sr-only">(página atual)</span></a>
          </li>
            <li class="nav-item"><a class="nav-link" @click="route('cupons')"  href="javascript:void(0)">  Cupons </a></li>
            <li class="nav-item"><a class="nav-link" @click="route('relatorio')"  href="javascript:void(0)">  Relatório </a></li>
            <li class="nav-item"><a class="nav-link" @click="route('promocoes')" href="javascript:void(0)">  Promoções</a></li>
            <li class="nav-item"><a class="nav-link" @click="route('usuarios')"     href="javascript:void(0)">  Usuários</a></li>
            <li class="nav-item"><a class="nav-link" @click="route('perfil')"   href="javascript:void(0)"> Perfil</a></li>
            <li class="nav-item"><a class="nav-link" @click="login()" href="javascript:void(0)"> Sair</a></li>
        </ul> 
   </div>
   <div class="menu-active-mobile">
      <a href="javascript:void(0)" @click="showMenuMobile()">
          <img src="/images/menu.svg" alt="Menu">
      </a>     
   </div>

 <notifications group="notify" position="top center"  />
 
 
 </div>
</template>

<script>
export default {
  name: "Menu",
  data:()=>{
    return {
      menu:"",
    }
  },
  methods: {
    route(path) {
      this.$router.push(`/${path}`);
    },
    showMenuMobile(){
         this.menu = "show-menu-mobile";
    },
    login(){

      this.$cookies.remove(process.env.VUE_APP_TOKEN_PARCEIRO);
      this.$router.push({name:"login"});

    }
    
  }
};
</script>
 